const Newsletter = function () {
    const _handleNewsletterPopup = function () {
        var stickyBtnClosed = false;
        var url = window.location.pathname;
        var stickyNewsletterBtnAllowedOnPage = typeof homePageUrl !== 'undefined' && url !== homePageUrl
            && typeof shopOnlineUrl !== 'undefined' && url !== shopOnlineUrl
            && !isInCheckoutPage()
            && !TINK.matchMediaMobileTablet();
        var newsletterNbPageVisited = parseInt(window.sessionStorage.getItem('newsletterNbPageVisited')) || 0;

        if(stickyNewsletterBtnAllowedOnPage && window.sessionStorage.getItem('newsletterNbPageVisited') < 2) {
            setTimeout(function(){
                if(!stickyBtnClosed) {
                    window.sessionStorage.setItem('newsletterNbPageVisited', newsletterNbPageVisited+1);
                }
            }, 3000);
            $('.sticky-newsletter-btn-container').fadeIn(500);
        } else {
            $('.sticky-newsletter-btn-container').hide();
        }

        $('.sticky-newsletter-btn').click(function(){
            _displayNewsletterPopup();
        });

        $('#closeStickyNewsletterBtn').click(function(){
            window.sessionStorage.setItem('newsletterNbPageVisited', 2);
            $('.sticky-newsletter-btn-container').hide();
            stickyBtnClosed = true;
        });
    }

    const _displayNewsletterPopup = function () {
        let $newsletterPopUpContainer = $('#newsletter-popup-container');
        if ($newsletterPopUpContainer.hasClass('remodal-is-closed')) {
            $newsletterPopUpContainer.remodal().open();
        }
    }

    return {
        handleNewsletterPopup: _handleNewsletterPopup,
        displayNewsletterPopup: _displayNewsletterPopup,
    };
}();

jQuery(document).ready(function () {
    var $newsletterDivExists = $('.newsletter-box-wrapper').length;
    if ($newsletterDivExists) {
        $(window).scroll(function () {
            var scroll = $(window).scrollTop();
            if (scroll >= 150) {
                $(".sticky-newsletter-btn-container").addClass("active-newsletter-btn");
            } else {
                $(".sticky-newsletter-btn-container").removeClass("active-newsletter-btn");
            }
        });

        Newsletter.handleNewsletterPopup();
    }
});